import { Injectable } from '@angular/core';
import { NestApiProvider } from '../../nest-api';
import { Observable } from 'rxjs/Rx';
import { ResponseEaForm, ResultPayslipDetail } from './sf-payslip.dto';
import { ResponseData } from '../../nest-responses';

@Injectable()
export class SfPayslipProvider {

  private _service: string = 'payroll';
  private _model: string = 'sfPayslip';
  private _model2: string = 'yearlyreportmy';

  constructor(private nestApiProvider: NestApiProvider) {
  }

  public getPayslipDetails(params: any): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'getPayslipDetail';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    if (typeof params !== 'undefined' && params !== null) _urlParams.params = params;

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _func, _params, _body);
  }

  public getEAForm(): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'listEaMyByEmp';
    const _params: any = '';
    const _urlParams: any = {};
    const _body: any = {};

    const _url = this.nestApiProvider.urlBuilder(_method, this._model2, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _func, _params, _body);
  }

  public downloadEAForm(params: any): Observable<ResponseData<ResponseEaForm[]>> {
    const _method: string = 'POST';
    const _func: string = 'formEaMybyEmp';
    const _params: any = params || {};
    const _urlParams: any = {};
    const _body: any = {};

    const _url = this.nestApiProvider.urlBuilder(_method, this._model2, _func, {}, _urlParams, this._service);
    // this.fileDownloaderProvider.downloadWithHttpEA(_url, 'EAForm.pdf');
    return this.nestApiProvider.requestBlob(_method, _url, _params, _urlParams, _body);
  }

  public downloadPayslipThV2(procmtdhId: any, download: string): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'downloadPayslip';
    const _params: any = {};
    const _urlParams = {
      params: []
    };
    const _body: any = {};

    if (typeof procmtdhId !== 'undefined' && procmtdhId !== null) _urlParams.params['procmtdh_id'] = procmtdhId;
    if (typeof download !== 'undefined' && download !== null) _urlParams.params['download'] = download;

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.requestBlob(_method, _url, _func, _params, _body);
  }

  public sendPayslipThV2(procmtdhId: any): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'downloadPayslipThV2';
    const _params: any = {};
    const _urlParams = {
      params: []
    };
    const _body: any = {};

    if (typeof procmtdhId !== 'undefined' && procmtdhId !== null) _urlParams.params['procmtdh_id'] = procmtdhId;

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.requestBlob(_method, _url, _func, _params, _body);
  }

  public postDownloadPayslipThAll(params: any): Observable<any> {
    const _method: string = 'POST';
    const _func: string = 'downloadPayslipThAll';
    const _params: any = params || {};
    const _urlParams: any = {};
    const _body: any = {};

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, {}, _urlParams, this._service);
    return this.nestApiProvider.requestBlobWithProgress(_method, _url, _params, _urlParams, _body);
  }

  public downloadPayslip(procmtdhId: any, download: string, clang?: string): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'downloadPayslip';
    const _params: any = {};
    const _urlParams = {
      params: []
    };
    const _body: any = {};

    if (typeof procmtdhId !== 'undefined' && procmtdhId !== null) _urlParams.params['procmtdh_id'] = procmtdhId;
    if (typeof download !== 'undefined' && download !== null) _urlParams.params['download'] = download;
    if (typeof clang !== 'undefined' && clang !== null) _urlParams.params['clang'] = clang;

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.requestBlob(_method, _url, _func, _params, _body);
  }

  public getPaySlipSF6(params: any): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'getPaySlipSF6';
    const _params: any = {};
    const _urlParams = { params }
    const _body: any = {};

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.requestBlob(_method, _url, _func, _params, _body);
  }

  public getPayslipDetailSF6(params: any): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'getPayslipDetailSF6';
    const _params: any = {};
    const _urlParams: any = { params }
    const _body: any = {};
    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, 'attendance');
    return this.nestApiProvider.request(_method, _url, _func, _params, _body);
  }

  public getSPTSF6(procytdhid: any): Observable<any> {
    const _method: string = 'GET';
    const _modelspt: string = 'sf6s/spt1721a1'; //controller name
    const _func: string = 'gdDownloadPaySlipSF6'; //function controller
    const _params: any = {};
    const _urlParams = {
      params: []
    };
    const _body: any = {};

    if (typeof procytdhid !== 'undefined' && procytdhid !== null) _urlParams.params['procytdh_id'] = procytdhid;

    const _url = this.nestApiProvider.urlBuilder(_method, _modelspt, _func, _params, _urlParams, 'attendance');
    return this.nestApiProvider.requestBlob(_method, _url, _func, _params, _body);
  }

  public getPayslipDetailTh(params: any): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'getPayslipDetailTh';
    const _params: any = {};
    const _urlParams: any = {
      params: []
    };
    const _body: any = {};

    if (typeof params !== 'undefined' && params !== null) _urlParams.params = params;
    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _func, _params, _body);
  }

  public getPayslipDetailMy(params: any): Observable<ResponseData<ResultPayslipDetail>> {
    const _method: string = 'GET';
    const _func: string = 'getpayslipdetailmy';
    const _params: any = {};
    const _urlParams: any = params || {}
    const _body: any = {};

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request<ResponseData<ResultPayslipDetail>>(_method, _url, _func, _params, _body);
  }

  public getPayslipDetailNew(params: any): Observable<any> {
    const _method: string = 'POST';
    const _func: string = 'getPayslipDetailNew';
    const _params: any = params || {};
    const _urlParams: any = {};
    const _body: any = {};

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, {}, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body);
  }

  public getPayslipDetailSF6New(params: any): Observable<any> {
    const _method: string = 'POST';
    const _func: string = 'getPayslipDetailSF6New';
    const _params: any = params || {};
    const _urlParams: any = {};
    const _body: any = {};

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, {}, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body);
  }

  // public getPayslipDirectSF6New(params: any): Observable<any> {
  //   const _method: string = 'POST';
  //   const _func: string = 'getPayslipSF6New';
  //   const _params: any = params || {};
  //   const _urlParams: any = {};
  //   const _body: any = {};

  //   const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, {}, _urlParams, this._service);
  //   return this.nestApiProvider.requestBlob(_method, _url, _params, _urlParams, _body);
  // }

  public getPayslipDirectSF6New(params: any): Observable<any> {
    const _method: string = 'POST';
    const _func: string = 'getPayslipSF6New';
    const _params: any = params || {};
    const _urlParams: any = {};
    const _body: any = {};

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, {}, _urlParams, this._service);
    // this.fileDownloaderProvider.downloadWithHttpEA(_url, 'EAForm.pdf');
    return this.nestApiProvider.requestBlob(_method, _url, _params, _urlParams, _body);
  }

  public getUrlPayslipDirectSF6New() {
    const _method: string = 'POST';
    const _func: string = 'getPayslipSF6New';
    const _urlParams: any = {};
    // const _body: any = {};

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, {}, _urlParams, this._service);
    // this.fileDownloaderProvider.downloadWithHttpEA(_url, 'EAForm.pdf');
    return _url;
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/payroll/sf-payslip/sf-payslip.ts